import { observable, makeObservable } from 'mobx';
import {QuizQuestion} from 'main/stores/questions';
import Folder from 'main/stores/folders/Folder';

class Question extends QuizQuestion {
  description;
  uploadToEmployeeProfile;
  attachmentFolder;
  _relations = {
    attachmentFolder: Folder
  };

  constructor(other) {
    super();

    makeObservable(this, {
      description: observable,
      uploadToEmployeeProfile: observable,
      attachmentFolder: observable
    });

    this.merge(other);
  }
}

export default Question;
